import { useEffect, useState } from "react";

export function useAnimatedNumber(target, duration = 2000) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!target) return;

    let start = 0;
    const stepTime = 20;
    const increment = target / (duration / stepTime);

    const timer = setInterval(() => {
      start += increment;

      if (start >= target) {
        setValue(target);
        clearInterval(timer);
      } else {
        setValue(Math.floor(start));
      }
    }, stepTime);

    return () => clearInterval(timer);
  }, [target, duration]);

  return value;
}
